const permitir_consultar_alunos_matriculados_por_escola_turma = {
  path: "/permitir-consultar-alunos-matriculados-por-escola-turma",
  redirect: "/permitir-consultar-alunos-matriculados-por-escola-turma",
  meta: {
    breadCrumb:
      "Processo de Matrículas - Permitir Consultar Alunos Matriculados Por Escola/Turma",
  },
  children: [
    {
      path: "/permitir-consultar-alunos-matriculados-por-escola-turma",
      name: "permitir-consultar-alunos-matriculados-por-escola-turma",
      component: () =>
        import(
          "@/views/PermitirConsultarAlunosMatriculadosPorEscolaTurma/PermitirConsultarAlunosMatriculadosPorEscolaTurma.vue"
        ),
    },
    {
      path: "/permitir-consultar-alunos-matriculados-por-escola-turma/consultar-alunos-por-turma/:ano_matricula/:turma_id",
      name: "consultar-alunos-por-turma",
      component: () =>
        import(
          "@/views/PermitirConsultarAlunosMatriculadosPorEscolaTurma/ConsultarAlunosPorTurma.vue"
        ),
    },
  ],
};

export { permitir_consultar_alunos_matriculados_por_escola_turma };
